import "core-js/modules/es.array.push.js";
import { defineComponent, reactive, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import 'nprogress/nprogress.css';
import { ElMessage } from 'element-plus';
export default {
  setup() {
    const state = reactive({
      count: 0
    });
    let router = useRouter();
    let methods = {
      goRealtime() {
        router.push('/home');
      },
      goInternet() {
        router.push('/home2');
      },
      goSearch() {
        router.push('/home3');
      },
      goGuPiao() {
        router.push('/home5');
      },
      goYaopin() {
        ElMessage.success('暂时没有权限');

        //    history.back()
      },

      goProduct() {
        router.push('/product3');
      },
      goCommondis() {
        router.push('/commondis');
      },
      goNumber() {
        router.push('/ecologicalGrowth');
      },
      goYp() {
        router.push('/fzYp');
      },
      goYjy() {
        router.push('/numberStore');
      },
      goFzsq() {
        router.push('/digitalEnterprise');
      }
    };
    return {
      ...toRefs(state),
      ...methods
    };
  }
};